export default __webpack_public_path__ + "static/media/positive_logo.4a6f1733.png";